<p>sidebar-block works!</p>
<app-sidebar-title></app-sidebar-title>
<app-sidebar-item *ngFor="let item of items" [item]="item"></app-sidebar-item>
